export default __webpack_public_path__ + "static/brace-937bdf235558e1e8efd47a2abb4ace90.png";